/* src/app/component/trip-update-card/trip-update-card.component.scss */
/*# sourceMappingURL=trip-update-card.component-KHY4IXNB.css.map */
